'use client';

import { deepCopy } from "@/fx/data-helpers";
import { SAMPLE_DATA } from "./sample-data";
import { CLM } from "../../common/schema/claims";
import { InMemoryRecords } from "@/fx/record-handling";
import assert from "assert";
import { SERVICES } from "../services";

export class InMemoryDataRepository
{
  private readonly globalSettings_: CLM.GlobalSettings = {};

  constructor({ dataGenerator }: { dataGenerator: SAMPLE_DATA.DataGenerator })
  {
    this.wholesalerRecords.insertAll(dataGenerator.seedWholesalers);
    // this.claimRecords     .insertAll(dataGenerator.seedClaims     );
  }

  readonly globalSettings = () => deepCopy(this.globalSettings_);

  readonly dataContext: () => () => CLM.DataContext = () => {

    return (() => {

      assert(this.initializationComplete);
      const now                      = new Date();
      const { CTX }                  = SERVICES();
      const currentUser              = CTX.useCurrentUser();
      assert(currentUser,            "Current user is not defined");
      const globalSettings           = this.globalSettings();
      const wholesalerBySapIdIfExist = this.wholesalerBySapIdIfExist;

      return { now, currentUser, globalSettings, wholesalerBySapIdIfExist };

    }).bind(this);
  }

  readonly claimCleanupContext: () => () => CLM.ClaimCleanupContext = () => CLM.claimCleanupContext(this.dataContext());

  readonly fromRawClaim = CLM.fromRawClaim(
    this.claimCleanupContext()
  );
  readonly toRawClaim = CLM.toRawClaim;

  readonly fromRawProductLineItem = CLM.fromRawProductLineItem;
  readonly toRawProductLineItem   = CLM.toRawProductLineItem;

  readonly fromRawProduct = CLM.fromRawProduct;
  readonly toRawProduct   = CLM.toRawProduct;

  readonly fromRawDistributor = CLM.fromRawDistributor;
  readonly toRawDistributor   = CLM.toRawDistributor;

  readonly fromRawDistributorLocation = CLM.fromRawDistributorLocation;
  readonly toRawDistributorLocation   = CLM.toRawDistributorLocation;

  readonly fromRawBbcEmployee = CLM.fromRawBbcEmployee;
  readonly toRawBbcEmployee   = CLM.toRawBbcEmployee;

  readonly fromRawUlca = CLM.fromRawUlca;
  readonly toRawUlca   = CLM.toRawUlca;

  readonly fromRawIssue = CLM.fromRawIssue;
  readonly toRawIssue   = CLM.toRawIssue;

  readonly wholesalerRecords = new InMemoryRecords<CLM.WholesalerId, CLM.Wholesaler>({});

  readonly wholesalers = this.wholesalerRecords.all.bind(this.wholesalerRecords);

  readonly wholesaler = this.wholesalerRecords.single.bind(this.wholesalerRecords);

  readonly wholesalerBySapIdIfExist = (sapId: string) => {
    if (sapId === undefined) throw new Error(`Parameter sapId must be defined. It is ${sapId}.`);
    if (sapId === null     ) throw new Error(`Parameter sapId must be defined. It is ${sapId}.`);

    return this.wholesalers().find(_ => _.sapId === sapId);
  }

  private readonly initializationComplete = true;
}
